import gazetteer from '@bridebook/toolbox/src/gazetteer';

/**
 * The app languages the settings dropdown offers — every monetized market's
 * primary locale. Data-only, so both the AI action's schema and its executor
 * derive the same list without pulling in any client code.
 */
export const getSupportedAppLocales = () =>
  gazetteer
    .getMarkets()
    .filter((market) => !!market.flags.monetized)
    .map((market) => market.locale);
